import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipOcr, TPostClipOcr } from '../types';

export async function postClipOcr(body: TPostClipOcr): Promise<TClipOcr> {
  return mediaManagerClient
    .post('/api/v1/clip_ocr', emptyStringValues(body))
    .then(response => response as unknown as TClipOcr);
}

type MutationFn = typeof postClipOcr;

type TUsePostClipOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostClipOcr({ config }: TUsePostClipOcrParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postClipOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido crear el rótulo del corte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del corte se ha creado correctamente'));
    },
  });
}
